<section class="d-flex flex-column section-logged-user">
    <div class="d-flex flex-column p-3">
        <div class="p-0 d-flex flex-row-reverse">
            <div style="cursor: pointer;" (click)="fecharModal()">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
                </svg>
            </div>
        </div>
        <div class="d-flex flex-column py-2 px-3">
            <span style="font-size: 1.2rem; text-align: left" class="bi bi-download">
                Baixar Relatório Entregas de arquivos - DeSTDA
            </span>
            <span style="font-size: 0.7rem; text-align: left; text-decoration-color: dimgrey;">
                Escolha o período que deseja efetuar o download do relatorio
            </span>
        </div>
        <div class="d-flex flex-row p-2 position-relative vertical_align_center"
            style="margin-top: 1rem">
            <div class="p-1">
                <mat-form-field style="width: 20rem; margin-right: 3rem">
                    <mat-label style="font-size: 1rem">Período Inicial</mat-label>
                    <input  matInput placeholder=""
                            value=""
                            mask="00/0000"
                            placeholder="mm/aaaa"
                            [formControl]="periodoInicio"
                            id="anoMesinicio" />
                            <mat-error *ngIf="periodoInicio.invalid && (periodoInicio.dirty || periodoInicio.touched)">
                                {{periodoInicio.errors?.invalidDate}}
                            </mat-error>
                </mat-form-field>
                <mat-form-field style="width: 20rem; margin-right: 3rem">
                    <mat-label style="font-size: 1rem">Período Final</mat-label>
                    <input  matInput placeholder=""
                            value=""
                            mask="00/0000"
                            placeholder="mm/aaaa"
                            [formControl]="periodoTermino"
                            id="anoMesFinal" />
                            <mat-error *ngIf="periodoTermino.invalid && (periodoTermino.dirty || periodoTermino.touched)">
                                {{periodoTermino.errors?.invalidDate}}
                            </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="p-3 d-flex flex-row-reverse">
            <sfz-button title="Emitir"
                        startIcon="search"
                        (click)="emitirRelatorio()"
                        size="sm">
            </sfz-button> 
        </div>
    </div>
</section>
